(function(){
  'use strict';

  var STORE_KEY = 'vandilimz:wishlist:v2';
  var routes = (window.VanDilimz && window.VanDilimz.routes) || {};

  function route(path){
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || routes.root || '/';
    return root.replace(/\/$/, '/') + String(path || '').replace(/^\//, '');
  }

  function getWishlist(){
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || []; }
    catch(error){ return []; }
  }

  function saveWishlist(items){
    localStorage.setItem(STORE_KEY, JSON.stringify(items));
    updateWishlistCount();
    updateWishlistButtons();
  }

  function updateWishlistCount(){
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el){ el.textContent = count; });
  }

  function updateCartCount(count){
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
  }

  function escapeHtml(value){
    return String(value || '').replace(/[&<>"']/g, function(char){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char];
    });
  }
  function escapeAttr(value){ return escapeHtml(value).replace(/`/g, '&#096;'); }

  function money(cents){
    cents = Number(cents || 0);
    var value = (cents / 100).toFixed(2);
    var format = (window.VanDilimz && window.VanDilimz.moneyFormat) || '${{ amount }}';
    return format
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  }

  function parseError(response){
    return response.json().then(function(data){
      throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
    }).catch(function(error){
      if (error && error.message) throw error;
      throw new Error('Something went wrong. Please try again.');
    });
  }

  function showStatus(form, message, isError){
    var status = form && (form.querySelector('[data-form-status]') || form.querySelector('[data-cart-status]'));
    if (!status) status = document.querySelector('[data-cart-status]');
    if (!status) return;
    status.textContent = message;
    status.className = 'form-status ' + (isError ? 'form-status--error' : 'form-status--success');
  }

  function updateWishlistButtons(){
    var handles = getWishlist().map(function(item){ return item.handle; });
    document.querySelectorAll('[data-wishlist-button]').forEach(function(button){
      var handle = button.getAttribute('data-product-handle');
      var active = handles.indexOf(handle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      var heart = button.querySelector('.heart-symbol');
      if (heart) heart.textContent = active ? '♥' : '♡';
    });
  }

  function toggleWishlist(button){
    var handle = button.getAttribute('data-product-handle');
    if (!handle) return;
    var variantId = button.getAttribute('data-variant-id') || '';
    var currentSelect = document.querySelector('[data-variant-select]');
    if (currentSelect && currentSelect.value) variantId = currentSelect.value;
    var items = getWishlist();
    var index = items.findIndex(function(item){ return item.handle === handle; });
    if (index > -1) {
      items.splice(index, 1);
    } else {
      items.push({
        handle: handle,
        title: button.getAttribute('data-product-title') || 'Product',
        url: button.getAttribute('data-product-url') || '#',
        image: button.getAttribute('data-product-image') || '',
        price: button.getAttribute('data-product-price') || '',
        variantId: variantId
      });
    }
    saveWishlist(items);
    renderWishlistPage();
  }

  function renderWishlistPage(){
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;
    var items = getWishlist();
    grid.innerHTML = '';
    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    items.forEach(function(item){
      var col = document.createElement('div');
      col.className = 'col-6 col-md-4 col-lg-3';
      col.innerHTML = '<article class="wishlist-card">' +
        '<a href="'+escapeAttr(item.url)+'">' +
          (item.image ? '<img src="'+escapeAttr(item.image)+'" alt="'+escapeAttr(item.title)+'" loading="lazy">' : '') +
        '</a>' +
        '<div class="wishlist-card__content">' +
          '<h2 class="product-name"><a href="'+escapeAttr(item.url)+'">'+escapeHtml(item.title)+'</a></h2>' +
          '<div class="product-price"><span>'+escapeHtml(item.price)+'</span></div>' +
          '<div class="wishlist-card__actions">' +
            '<button type="button" class="button button--small" data-wishlist-add-cart data-variant-id="'+escapeAttr(item.variantId)+'">Add to cart</button>' +
            '<button type="button" class="text-button" data-wishlist-remove data-handle="'+escapeAttr(item.handle)+'">Remove</button>' +
          '</div>' +
        '</div>' +
      '</article>';
      grid.appendChild(col);
    });
  }

  function removeWishlistItem(handle){
    saveWishlist(getWishlist().filter(function(item){ return item.handle !== handle; }));
    renderWishlistPage();
  }

  function addToCart(form){
    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    fetch(routes.cart_add || route('cart/add.js'), {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
    .then(function(response){ if (!response.ok) return parseError(response); return response.json(); })
    .then(function(){ return fetch(route('cart.js'), { headers: { 'Accept': 'application/json' } }); })
    .then(function(response){ return response.json(); })
    .then(function(cart){
      updateCartCount(cart.item_count);
      showStatus(form, 'Added to cart.', false);
    })
    .catch(function(error){ showStatus(form, error.message, true); })
    .finally(function(){ if (button) button.disabled = false; });
  }

  function addVariantToCart(variantId, button){
    if (!variantId) return;
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    if (button) button.disabled = true;
    fetch(routes.cart_add || route('cart/add.js'), { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function(response){ if (!response.ok) return parseError(response); return response.json(); })
      .then(function(){ return fetch(route('cart.js'), { headers: { 'Accept': 'application/json' } }); })
      .then(function(response){ return response.json(); })
      .then(function(cart){ updateCartCount(cart.item_count); if (button) button.textContent = 'Added'; })
      .catch(function(error){ if (button) button.textContent = error.message; })
      .finally(function(){ setTimeout(function(){ if (button) { button.disabled = false; button.textContent = 'Add to cart'; } }, 1800); });
  }

  function cssEscape(value){
    if (window.CSS && CSS.escape) return CSS.escape(value);
    return String(value).replace(/"/g, '\\"');
  }

  function changeCartLine(key, quantity){
    var status = document.querySelector('[data-cart-status]');
    if (status) status.textContent = 'Updating cart...';
    fetch(routes.cart_change || route('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Number(quantity) })
    })
    .then(function(response){ if (!response.ok) return parseError(response); return response.json(); })
    .then(function(cart){
      updateCartCount(cart.item_count);
      var subtotal = document.querySelector('[data-cart-subtotal]');
      document.querySelectorAll('[data-cart-subtotal]').forEach(function(el){ el.textContent = money(cart.total_price); });
      cart.items.forEach(function(item){
        var line = document.querySelector('[data-cart-line][data-line-key="'+cssEscape(item.key)+'"]');
        if (line) {
          var total = line.querySelector('[data-line-total]');
          if (total) total.textContent = money(item.final_line_price);
        }
      });
      document.querySelectorAll('[data-cart-line]').forEach(function(line){
        var lineKey = line.getAttribute('data-line-key');
        var stillExists = cart.items.some(function(item){ return item.key === lineKey; });
        if (!stillExists) line.remove();
      });
      if (status) status.textContent = 'Cart updated.';
      if (cart.item_count === 0) window.location.reload();
    })
    .catch(function(error){ if (status) status.textContent = error.message; });
  }


  function ensureWishlistRoute(){
    var params = new URLSearchParams(window.location.search);
    if (params.get('view') !== 'wishlist') return;
    if (document.querySelector('[data-wishlist-grid]')) return;
    var main = document.getElementById('PageContainer');
    if (!main) return;
    main.innerHTML = '<div class="page-header text-center"><div class="container"><h1 class="page-title">Wishlist</h1><p>Your saved VanDilimz favorites.</p></div></div><section class="container wishlist-page-section"><div class="wishlist-toolbar"><p data-wishlist-empty>Your wishlist is empty. Save products by clicking the heart icon.</p></div><div class="row wishlist-grid" data-wishlist-grid></div></section>';
  }


  function setHomepageHeaderOffset(){
    function update(){
      var height = 0;
      if (document.body && document.body.classList.contains('template-index')) {
        var bar = document.querySelector('.announcement-bar');
        height = bar ? bar.offsetHeight : 0;
      }
      document.documentElement.style.setProperty('--vdz-announcement-height', height + 'px');
    }
    update();
    window.addEventListener('resize', update);
  }

  function initHero(context){
    var root = context || document;
    var sliders = Array.prototype.slice.call(root.querySelectorAll('[data-hero-slider]'));
    if (!sliders.length && root.matches && root.matches('[data-hero-slider]')) sliders = [root];
    sliders.forEach(function(slider){
      if (slider.getAttribute('data-hero-ready') === 'true') return;
      var slides = Array.prototype.slice.call(slider.querySelectorAll('.swiper-slide'));
      if (!slides.length) return;
      slider.setAttribute('data-hero-ready', 'true');
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-hero-dot]'));
      var index = slides.findIndex(function(slide){ return slide.classList.contains('is-active'); });
      if (index < 0) index = 0;
      slides.forEach(function(slide, slideIndex){ slide.classList.toggle('is-active', slideIndex === index); });
      dots.forEach(function(dot, dotIndex){ dot.classList.toggle('active', dotIndex === index); });
      function show(next){
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('active');
        index = (next + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('active');
      }
      var nextBtn = slider.querySelector('[data-hero-next]');
      var prevBtn = slider.querySelector('[data-hero-prev]');
      if (nextBtn) nextBtn.addEventListener('click', function(){ show(index + 1); });
      if (prevBtn) prevBtn.addEventListener('click', function(){ show(index - 1); });
      dots.forEach(function(dot){ dot.addEventListener('click', function(){ show(Number(dot.getAttribute('data-hero-dot'))); }); });
      if (slides.length > 1 && slider.getAttribute('data-hero-autoplay') === 'true') {
        var speed = Number(slider.getAttribute('data-hero-speed') || 7000);
        if (!speed || speed < 1000) speed = 7000;
        setInterval(function(){ show(index + 1); }, speed);
      }
    });
  }

  function initMobileMenu(){
    var button = document.querySelector('[data-mobile-menu-button]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!button || !menu) return;
    button.addEventListener('click', function(){
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      menu.hidden = expanded;
    });
  }


  function initMobileSubmenus(){
    document.querySelectorAll('[data-mobile-submenu-button]').forEach(function(button){
      var parentRow = button.closest('.mobile-menu-parent');
      var panel = parentRow ? parentRow.nextElementSibling : null;
      if (!panel || !panel.classList || !panel.classList.contains('mobile-submenu')) return;
      button.addEventListener('click', function(event){
        event.preventDefault();
        event.stopPropagation();
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
      });
    });
  }

  function initFooterAccordions(){
    var accordions = Array.prototype.slice.call(document.querySelectorAll('[data-footer-accordion]'));
    if (!accordions.length) return;
    var mq = window.matchMedia('(max-width: 991px)');
    var lastIsMobile = null;

    function setPanel(panel, open, mobile){
      if (!panel) return;
      if (mobile) {
        panel.hidden = !open;
        panel.style.display = open ? 'block' : 'none';
      } else {
        panel.hidden = false;
        panel.style.display = 'block';
      }
    }

    function applyState(){
      var mobile = mq.matches;
      var switchedToMobile = mobile && lastIsMobile !== true;

      accordions.forEach(function(accordion){
        var button = accordion.querySelector('[data-footer-accordion-button]');
        var panel = accordion.querySelector('[data-footer-accordion-panel]');
        if (!button || !panel) return;

        button.removeAttribute('disabled');

        if (mobile) {
          if (switchedToMobile || !accordion.hasAttribute('data-footer-ready')) {
            button.setAttribute('aria-expanded', 'false');
            accordion.classList.remove('is-open');
          }
          var open = button.getAttribute('aria-expanded') === 'true';
          setPanel(panel, open, true);
        } else {
          button.setAttribute('aria-expanded', 'true');
          accordion.classList.add('is-open');
          setPanel(panel, true, false);
        }

        accordion.setAttribute('data-footer-ready', 'true');
      });

      lastIsMobile = mobile;
    }

    document.addEventListener('click', function(event){
      var button = event.target.closest('[data-footer-accordion-button]');
      if (!button) return;
      if (!mq.matches) return;

      event.preventDefault();
      var accordion = button.closest('[data-footer-accordion]');
      var panel = accordion && accordion.querySelector('[data-footer-accordion-panel]');
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (accordion) accordion.classList.toggle('is-open', !open);
      setPanel(panel, !open, true);
    });

    applyState();
    if (mq.addEventListener) {
      mq.addEventListener('change', applyState);
    } else if (mq.addListener) {
      mq.addListener(applyState);
    }
    window.addEventListener('resize', applyState);
  }


  function initSort(){
    var select = document.querySelector('[data-sort-select]');
    if (!select) return;
    select.addEventListener('change', function(){
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  }

  function initRecover(){
    var toggle = document.querySelector('[data-recover-toggle]');
    var form = document.querySelector('[data-recover-form]');
    if (!toggle || !form) return;
    toggle.addEventListener('click', function(event){ event.preventDefault(); form.hidden = !form.hidden; });
    if (window.location.hash === '#recover') form.hidden = false;
  }

  function initProductVariants(){
    var section = document.querySelector('[data-product-section]');
    if (!section) return;
    var select = section.querySelector('[data-variant-select]');
    var json = section.querySelector('[data-product-variants]');
    var mainImage = section.querySelector('[data-product-main-image]');
    var price = section.querySelector('[data-product-price]');
    var addButton = section.querySelector('[data-add-to-cart-button]');
    var wishButton = section.querySelector('[data-wishlist-button]');
    var variants = [];
    if (json) {
      try { variants = JSON.parse(json.textContent); } catch(error) { variants = []; }
    }
    if (!select || !variants.length) return;
    function update(){
      var id = Number(select.value);
      var variant = variants.find(function(v){ return Number(v.id) === id; });
      if (!variant) return;
      if (price) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          price.innerHTML = '<ins><span class="money">'+money(variant.price)+'</span></ins> <del><span class="money">'+money(variant.compare_at_price)+'</span></del>';
        } else {
          price.innerHTML = '<span class="money price">'+money(variant.price)+'</span>';
        }
      }
      if (mainImage && variant.featured_image) mainImage.setAttribute('src', variant.featured_image);
      if (addButton) {
        addButton.disabled = !variant.available;
        var span = addButton.querySelector('span');
        if (span) span.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
      if (wishButton) wishButton.setAttribute('data-variant-id', String(variant.id));
    }
    select.addEventListener('change', update);
  }

  function initProductGallery(){
    var main = document.querySelector('[data-product-main-image]');
    if (!main) return;
    document.querySelectorAll('[data-image-src]').forEach(function(button){
      button.addEventListener('click', function(){
        main.setAttribute('src', button.getAttribute('data-image-src'));
        document.querySelectorAll('[data-image-src]').forEach(function(btn){ btn.classList.remove('active'); });
        button.classList.add('active');
      });
    });
  }

  function initTabs(){
    document.querySelectorAll('[data-product-tab]').forEach(function(tab){
      tab.addEventListener('click', function(){
        var name = tab.getAttribute('data-product-tab');
        document.querySelectorAll('[data-product-tab]').forEach(function(t){ t.classList.remove('active'); });
        document.querySelectorAll('[data-tab-panel]').forEach(function(panel){ panel.classList.remove('active'); });
        tab.classList.add('active');
        var panel = document.querySelector('[data-tab-panel="'+name+'"]');
        if (panel) panel.classList.add('active');
      });
    });
    document.querySelectorAll('[data-tab-jump]').forEach(function(link){
      link.addEventListener('click', function(){
        var target = document.querySelector('[data-product-tab="'+link.getAttribute('data-tab-jump')+'"]');
        if (target) target.click();
      });
    });
  }

  document.addEventListener('click', function(event){
    var wish = event.target.closest('[data-wishlist-button]');
    if (wish) { event.preventDefault(); toggleWishlist(wish); return; }
    var remove = event.target.closest('[data-wishlist-remove]');
    if (remove) { event.preventDefault(); removeWishlistItem(remove.getAttribute('data-handle')); return; }
    var addSaved = event.target.closest('[data-wishlist-add-cart]');
    if (addSaved) { event.preventDefault(); addVariantToCart(addSaved.getAttribute('data-variant-id'), addSaved); return; }
    var cartRemove = event.target.closest('[data-cart-remove]');
    if (cartRemove) { event.preventDefault(); changeCartLine(cartRemove.getAttribute('data-line-key'), 0); }
  });

  document.addEventListener('submit', function(event){
    var form = event.target.closest('.js-product-form, .product-card-form');
    if (!form) return;
    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('change', function(event){
    var qty = event.target.closest('[data-cart-quantity]');
    if (qty) changeCartLine(qty.getAttribute('data-line-key'), qty.value);
  });

  function initTheme(context){
    ensureWishlistRoute();
    updateWishlistCount();
    updateWishlistButtons();
    renderWishlistPage();
    setHomepageHeaderOffset();
    initHero(context || document);
    initMobileMenu();
    initMobileSubmenus();
    initFooterAccordions();
    initSort();
    initRecover();
    initProductVariants();
    initProductGallery();
    initTabs();
  }

  document.addEventListener('DOMContentLoaded', function(){
    initTheme(document);
  });

  document.addEventListener('shopify:section:load', function(event){
    initTheme(event.target);
  });
})();
